<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="calibre_pb_0">
<p class="calibre8"><span id="Page_30" title="30"></span></p>
<h2 class="nobreak" id="II"><span class="calibre9" id="toclink_30"></span>II<br class="calibre5"/>
<span class="subhead">I GET TO PARIS AND ENCOUNTER SOME
STRANGE SIGHTS</span></h2>
</div>
<h3 class="calibre10" id="pgepubid00014"> <i class="calibre11">Friday, August 17. A French Port.</i></h3>
<p class="calibre8"><span class="firstword">In</span> obedience to the captain’s orders we remained
on deck last night, fully dressed, till our ship was
past the danger zone and in harbor. There was a
rule against smoking or lighting matches, but none
against conversation.</p>
<p class="calibre8">The Gentleman from Louisiana and a young
American Field Service candidate had the floor.
The former’s best was a report of what he saw once
while riding along beside the Columbia River. An
enormous salmon jumped out of the water and raced
six miles with the train before being worn out.
Whether the piscatorial athlete flew or rode a motorcycle,
we were unable to learn.</p>
<p class="calibre8">The Gentleman from Louisiana yielded to his<span id="Page_31" title="31"></span>
younger and stronger countryman. Some one had
spoken of the lack of convoy. “Don’t you think we
haven’t a convoy,” the kid remarked.</p>
<p class="calibre8">I scanned the sea in all directions and saw nothing
but the dark waters. “Where is it?” I inquired.</p>
<p class="calibre8">“There’s one on each side of us,” said Young
America. “They’re about twenty miles from the
ship.”</p>
<p class="calibre8">“I should think,” said somebody, “that a very
slender submarine might slip in between our side
kicks and us and do its regular job.”</p>
<p class="calibre8">“No chance,” the youth replied. “The convoy
boats are used as decoys. The sub would see them
first and spend all its ammunition.”</p>
<p class="calibre8">A little later he confided in me that the new
American war-ships were two hundred and forty-five
thousand horsepower. I had no idea there were
that many horses left to measure by.</p>
<p class="calibre8">We spotted a shooting star. “That was a big
one,” I said.</p>
<p class="calibre8">“Big! Do you know the actual size of those
things? I got it straight from a professor of astronomy.<span id="Page_32" title="32"></span>
Listen. They’re as small as a grain of
sand.”</p>
<p class="calibre8">“Why do they look so big?”</p>
<p class="calibre8">“Because they’re so far away and they travel so
fast.”</p>
<p class="calibre8">Round ten o’clock, beckoning lights ashore told
us we were close to safety. But the French gunners
remained at their posts two hours longer. The captain’s
shouted order, relieving them from duty, was
music to our ears.</p>
<p class="calibre8">After midnight, however, we turned a complete
circle, and at once the deck was alive with rumors.
We had been hit, we were going to be hit, we were
afraid we would be hit, and so on. The fact was
that our pilot from ashore was behind time and we
circled round rather than stand still and be an easy
target while awaiting him. We were in harbor and
anchored at three. Many of us stayed up to see the
sun rise over France. It was worth the sleep it cost.</p>
<p class="calibre8">They told us we would not dock until six to-night.
Before retiring to my cabin for a nap, I heard we
had run over a submarine and also that we had
not. The latter story lacked heart interest, but had<span id="Page_33" title="33"></span>
the merit, probably, of truth. Submarines have little
regard for traffic laws, but are careful not to
stall their engines in the middle of a boulevard.</p>
<p class="calibre8">I was peacefully asleep when the French officers
came aboard to give us and our passports the
Double O. They had to send to my cabin for me.
I was ordered to appear at once in the salon de conversation.
A barber hater addressed me through his
beard and his interpreter: “What is Monsieur Laudanum’s
business in France?”</p>
<p class="calibre8">I told him I was a correspondent.</p>
<p class="calibre8">“For who?”</p>
<p class="calibre8">“Mark Sullivan.”</p>
<p class="calibre8">“Have you credentials from him?”</p>
<p class="calibre8">“No, sir.”</p>
<p class="calibre8">“Your passport says you are going to Belgium.
Do you know there are no trains to Belgium?”</p>
<p class="calibre8">“I know nothing about it.”</p>
<p class="calibre8">“Well, there are no trains. How will you go
there?”</p>
<p class="calibre8">“I’ll try to get a taxi,” I said.</p>
<p class="calibre8">“Are you going from here to Paris?”</p>
<p class="calibre8">“Yes.”</p>
<p class="calibre8"><span id="Page_34" title="34"></span></p>
<p class="calibre8">“And where are you going from Paris?”</p>
<p class="calibre8">“I don’t know.”</p>
<p class="calibre8">“Please explain that answer.”</p>
<p class="calibre8">“I will go wherever the authorities permit me to
go.”</p>
<p class="calibre8">“That is not a satisfactory answer.”</p>
<p class="calibre8">“I’m sorry.”</p>
<p class="calibre8">“What is your real business in France?”</p>
<p class="calibre8">“To write.”</p>
<p class="calibre8">“I’m afraid we’ll have to keep your passport.
You will appear to-morrow morning at nine o’clock
at this address.”</p>
<p class="calibre8">And they handed me a scary-looking card.</p>
<p class="calibre8">On the deck I met our congressman and told him
my troubles.</p>
<p class="calibre8">“I know these fellows very well,” he said. “If
you like, I can fix it for you.”</p>
<p class="calibre8">“No,” I replied proudly. “I’d rather do my own
fixing.”</p>
<p class="calibre8">At the dock I got into a taxi and asked to be
taken to the —— Hotel. Not to my dying day
will I forget that first ride in a French taxi. Part
of the time we were on the right side of the street,<span id="Page_35" title="35"></span>
part of the time on the left, and never once were
we traveling under a hundred and fifty miles an
hour. We turned twenty corners and always on one
ear. We grazed dozens of frightened pedestrians,
many of them men crippled in the war, or by taxis,
and women too old to dodge quickly. We aimed at a
score of rickety horse-drawn vehicles, but our control
was bad and we bumped only one. In front of
the hostelry we stopped with a jerk.</p>
<p class="calibre8">“Comme beaucoup?” I asked the assassin.</p>
<p class="calibre8">“Un franc cinquante,” he said.</p>
<p class="calibre8">Only thirty cents, and I thought I knew why.
When they get through a trip without killing any
one, they feel they have not done themselves justice
nor given you a square deal.</p>
<p class="calibre8">I found myself a seat at a sidewalk table and
ordered sustenance. The vial they brought it in
was labeled “Bière Ritten,” but I suspect the adjective
was misspelled.</p>
<p class="calibre8">Till darkness fell I watched the passing show—street-cars
with lady motormen and conductors;
hundreds of old carts driven by old women, each
cart acting as a traveling roof for an old dog;<span id="Page_36" title="36"></span>
wounded soldiers walking or hobbling along, some
of them accompanied by sad-faced girls; an appalling
number of women in black; a lesser number of
gayly garbed and extremely cordial ones, and whole
flocks of mad taxis, seeking whom they might devour.</p>
<p class="calibre8">By using great caution at the street crossings, I
succeeded in reaching the telegraph office where I
wrote a message informing Paris friends of my
arrival. I presented it to the lady in the cage, who
handed it back with the advice that it must be rewritten
in French. I turned away discouraged and
was starting out again into the gloom when I beheld
at a desk the songbird of the ship. Would she be
kind enough to do my translating? She would.</p>
<p class="calibre8">The clerk approved the new document, and asked
for my passport. I told her it had been taken away.
She was deeply grieved, then, but without it monsieur
could send no message. Bonne nuit!</p>
<p class="calibre8">Back at the hotel I encountered the Yankee vice-consul,
a gentleman from Bedford, Indiana. I told
him my sad plight, and he said if matters got too
serious his office would undertake to help.</p>
<p class="calibre8"><span id="Page_37" title="37"></span></p>
<p class="calibre8">With his assurances to comfort me, I have retired
to my room to write, to my room as big as Texas
and furnished with all the modern inconveniences.</p>
<h3 class="calibre10" id="pgepubid00015"> <i class="calibre11">Saturday, August 18. Paris.</i></h3>
<p class="calibre8">It is Saturday night and they have hot water, but
before I take advantage of it I must recount the
thrilling experiences of the day.</p>
<p class="calibre8">After a sidewalk breakfast of “oofs” and so-called
café in Bordeaux, I went to keep my engagement
at court. It was apparent that I was not the
only suspect. The walk outside and the room within
were crowded with shipmates, most of them from the
second cabin, all looking scared to death.</p>
<p class="calibre8">I stood in line till I realized that I must make it
snappy if I wanted to catch the eleven-five for
Paris; then I butted my way into the august presence
of Him of the Beard.</p>
<p class="calibre8">He recognized me at once and told me with his
hands to go up-stairs. In a room above I found
the English-speaking cross-examiner, with the accent
on the cross.</p>
<p class="calibre8">He waved me to a chair and began his offensive.</p>
<p class="calibre8"><span id="Page_38" title="38"></span></p>
<p class="calibre8">“Monsieur Laudanum,” he said, “when I asked
you yesterday how you expected to get to Belgium,
you said something about a taxi. That answer was
not satisfactory. You have not explained anything
to us. I do not believe we can allow you to leave
Bordeaux.”</p>
<p class="calibre8">“All right, sir.” I arose.</p>
<p class="calibre8">“Sit down!” he barked. “Now tell me if you
have any explanations to make.”</p>
<p class="calibre8">“Nothing beyond what I said yesterday. I have
come here to write. I want to go to Paris, and when
I arrive there I will find out where else I will be
permitted to go.”</p>
<p class="calibre8">“It seems very strange to me that you have no
papers.”</p>
<p class="calibre8">“Yes, sir.”</p>
<p class="calibre8">“Have you any?”</p>
<p class="calibre8">I searched my pockets and produced a used-up
check book on a Chicago bank. The ogre read
every little stub and I felt flattered by his absorbed
interest. When he had spent some five minutes on
the last one, which recorded a certain painful transaction
between me and a man-eating garage, he<span id="Page_39" title="39"></span>
returned my book and said: “You don’t satisfy
me at all. You will have to stay here.”</p>
<p class="calibre8">“Suppose,” said I, “that the American consul
vouches for me.”</p>
<p class="calibre8">“That will make no difference. You do not seem
to realize that we are at war.”</p>
<p class="calibre8">“Not with America.”</p>
<p class="calibre8">“I don’t know your nationality.”</p>
<p class="calibre8">“I thought,” said I, “that my passport hinted at
it.”</p>
<p class="calibre8">“You will have to stay in Bordeaux,” was his
pertinent reply.</p>
<p class="calibre8">“Thank you, sir,” I said, and arose again.</p>
<p class="calibre8">“Sit down,” said he, “and wait a minute.”</p>
<p class="calibre8">He was out of the room five years.</p>
<p class="calibre8">“If he ever does come back,” I thought, “it will
be in the company of five or six large gendarmes.”</p>
<p class="calibre8">But when he came back he came alone.</p>
<p class="calibre8">“Here,” he said abruptly, “is your passport.
You will be permitted to go to Paris. We will keep
track of you there.” And he bowed me out of the
joint.</p>
<p class="calibre8">The crowd down-stairs seemed as great as ever,<span id="Page_40" title="40"></span>
and as scared. I picked my way through it with my
head held high, a free man.</p>
<p class="calibre8">I decided on a fiacre for my trip from hotel to
station. It would be safer, I thought. But I
learned, on our interminable way, that defensive
fighting in the streets of Bordeaux is far more
terrifying, far more dangerous than the aggressive
taxi kind. We were run into twice and just missed
more times than I could count, and besides my conveyance
was always on the verge of a nervous breakdown.
’Spite all the talk of periscopes and subs,
the journey across the ocean was parlor croquet
compared to my fiacre ride in Bordeaux.</p>
<p class="calibre8">While awaiting my turn at the ticket window I
observed at the gate a French soldier wearing a
large businesslike bayonet. “Probably to punch
tickets with,” I thought, but was mistaken. Another
gentleman attended to that duty, and the
soldier did not give me so much as the honor of a
glance.</p>
<p class="calibre8">Outside on the platform were a few of the Red
Cross and Y. M. C. A. men of our ship, and I
learned from them that one of their number had<span id="Page_41" title="41"></span>
suffered a sadder fate than I. He had tried to get
by on a Holland passport, viséed at the French consulate
in New York, and been quietly but firmly persuaded
to take the next boat back home.</p>
<p class="calibre8">I shared a compartment on the train with a native
of the Bronx, and a French lady who just couldn’t
make her eyes behave, and two bored-looking French
gentlemen of past middle age, not to mention in
detail much more baggage than there was room for.
The lady and the two gentlemen wore gloves, which
made the Bronxite and me feel very bourgeois.</p>
<p class="calibre8">Our train crew, with the possible exception of
the engineer and fireman whom I didn’t see, was
female, and, thinking I might some time require
the services of the porter, I looked in my dictionary
for the feminine of George.</p>
<p class="calibre8">To try my knowledge of française, I had purchased
at the station a copy of <i class="calibre6" lang="fr">Le Cri de Paris</i>. I
found that I could read it very easily by consulting
the dictionary every time I came to a word.</p>
<p class="calibre8">But the scenery and the people were more interesting
than <i class="calibre6" lang="fr">Le Cri</i>, the former especially. Perfect
automobile roads, lined with trees; fields, and truck<span id="Page_42" title="42"></span>
gardens in which aged men and women, young girls
and little boys were at work; green hills and valleys;
winding rivers and brooks, and an occasional château
or a town of fascinating architecture—these
helped to make us forget the heat and dust of the
trip and the ear-splitting shrieks of our engines.
No wonder the boche coveted his neighbor’s house.</p>
<p class="calibre8">We stopped for some time at one particularly
beautiful town and went out for air. I wondered
audibly concerning the name of the place. An
American companion looked at the signs round the
station.</p>
<p class="calibre8">“It’s Sortie,” he said.</p>
<p class="calibre8">But it wasn’t. It was Angoulême, and I wouldn’t
mind moving thither. My American friend was
probably from Exit, Michigan.</p>
<p class="calibre8">The discovery was made and reported that one
might go into the dining-car and smoke as much as
one liked without asking permission from the
maiden with the dreamy eyes. This car was filled
with French soldiers and officers going back to the
front after their holiday. There seemed to be as
many different uniforms as there were men, and the<span id="Page_43" title="43"></span>
scenery indoors was almost as brilliant as that outside.</p>
<p class="calibre8">It was about eight-thirty in the evening when we
reached Paris. The sophisticated soldiers engaged
their “redcaps” before they left the train, calling
to them through the open windows. The demand
was much greater than the supply, and I was among
the unfortunates who had to carry their own baggage.
I staggered to a street where a whole flotilla
of taxis was anchored, but when I asked for one the
person in charge said “No, no, no, no, no,” meaning
“No,” and pointed around the corner. I followed
his directions and landed on a boulevard along
which there was a steady procession of machines,
but it was fully twenty minutes before one came
that was going slow enough to stop.</p>
<p class="calibre8">Our city is not all lit up like a church these
nights, and it was impossible to see much of what
we passed on the way to the hotel.</p>
<p class="calibre8">At the desk an English clerk, dressed for a noon
wedding, gave me a blank to fill out. All the blank
wanted to know was my past family history. It is
to be sent, said the clerk, to the prefect of police.
I had no idea he was interested in me.</p>
<p class="calibre8"><span id="Page_44" title="44"></span></p>
<h3 class="calibre10" id="pgepubid00016"> <i class="calibre11">Sunday, August 19. Paris.</i></h3>
<p class="calibre8">When I get back to Chicago I shall insist that
my favorite restaurant place tables out on the walk.
It is more hygienic and much more interesting.</p>
<p class="calibre8">But Chicago, I’m afraid, can’t provide half as
much sidewalk entertainment as Paris. As I remember
the metropolis of Illinois, there is a sad
lack there of demonstrative affection on the streets.
In fact, I fear that a lady and gentleman who kissed
each other repeatedly at the corner of Madison and
Dearborn would be given a free ride to Central
Station and a few days in which to cool off. Such
an osculatory duel on Paris’s Grand Boulevard—also
known by a dozen other names—goes practically
unnoticed except by us Illinois hicks.</p>
<div class="figcenter2" id="il_3">
<img alt=" " class="calibre4" id="id-1826368612941133540" src="OEBPS/Images/3757041487943700252_i_044.jpg"/>
<div class="caption">Only a few were thoughtless enough not to stop and kiss a few
times in full view of our table
</div>
</div>
<p class="calibre8">An American officer and I—at the former’s expense—lunched
sur curb to-day. The food was
nothing to boast about, but we got an eyeful of
scenery. Soldiers—French, British and American—strolled
by constantly, accompanied by more or
less beautiful brunettes, and only a few were
thoughtless enough not to stop and kiss a few times<span id="Page_45" title="45"></span>
in full view of our table. We also observed the inmates
of passing taxis. No matter how wide the
back seat, the lady occupant invariably sat on her
escort’s lap. A five-passenger car in America is a
ten-passenger car in Paris, provided the chauffeur
has a girl of his own.</p>
<p class="calibre8">When the American officer was tired of buying,
I left him and sought out the <i class="calibre6">Chicago Tribune</i>
office, conveniently located above Maxim’s. The
editor was there, but he was also broke, so I went
back to the Ritz and got ready for bed.</p>
<p class="calibre8">The express office will be open to-morrow and I
will be a rich man.</p>
<h3 class="calibre10" id="pgepubid00017"> <i class="calibre11">Lundi, 20 Août. Paris.</i></h3>
<p class="calibre8">Went down to the express office and cashed a
large part of my order. Friends were with me, and
they immediately relieved me of most of the burden.
I was hungry for lunch, having had no breakfast.
Meat was what I wanted, and meat was what I
couldn’t get. Which led me to inquire into the
Rules de la vie of Paris.</p>
<p class="calibre8"><span id="Page_46" title="46"></span></p>
<p class="calibre8">1. Monday and Tuesday are meatless days.</p>
<p class="calibre8">2. All except Saturday and Sunday are heatless
days. Hot baths are impossible on Mondays,
Tuesdays, Wednesdays, Thursdays and Fridays.</p>
<p class="calibre8">3. Strong liquor is procurable between noon and
two <span class="firstword">P. M.</span> and seven-thirty and nine-thirty at night.
At other times ye toper must be content with light
wines.</p>
<p class="calibre8">4. All public places except the theaters must
close and douse lights at nine-thirty in the evening.</p>
<p class="calibre8">5. There is no speed limit for taxis or privately
owned cars. A pedestrian run over and killed is
liable to imprisonment. The driver is not only innocent,
but free to hurl as many French curses as he
likes at his victims. If the pedestrian is not killed,
he must explain why not to the judge.</p>
<p class="calibre8">6. It is not only permissible but compulsory to
speak to any girl who speaks to you, and a girl who
won’t speak to you should be reported to the police.</p>
<p class="calibre8">7. No watch or clock is wrong. Whatever
time you have is right and you may act accordingly.</p>
<p class="calibre8">8. Matches never ignite. A smoker must purchase
a cigar or cigarette lighter and keep it filled<span id="Page_47" title="47"></span>
with essence, the française term for gas. Sometimes
the lighters work.</p>
<p class="calibre8">9. American cigarettes are not procurable. Bum
ones may be bought at any tabac store or café for
only five times what they are worth.</p>
<p class="calibre8">10. Water must never be used as a thirst
quencher, and seldom for any other purpose. It’s
worse than bourgeois; it’s unheard-of.</p>
<p class="calibre8">The lack of water, hot or cold, drove me to a
barber shop this morning. The barber first made
me put on a shroud, and I was afraid he was either
going to cut me to pieces or talk me to death. But
his operation was absolutely painless and his incessant
conversation harmless, because I couldn’t
understand a word of it.</p>
<p class="calibre8">From the barber shop I went to the information
department of American Army Headquarters.
That’s where you get permits to visit our camps.
But of course, if you’ve run over here from America,
you have lots of spare time on your hands,
so they’re doing you a favor if they hold you up
a few days. What is a week or so when a man’s
here for a whole month?</p>
<p class="calibre8"><span id="Page_48" title="48"></span></p>
<p class="calibre8">They have queer ideas at the Maison de la Presse,
which is the French equivalent for our publicity
bureau. They receive you cordially there and treat
you just as if you were not dregs.</p>
<p class="calibre8">I jumped thither after a futile visit to our own
headquarters. I said I would like to go to the
French front.</p>
<p class="calibre8">“Certainly,” replied the man in charge. “Whenever
is convenient for you, we’ll see that you get a
trip.”</p>
<p class="calibre8">So I told him when it would be convenient and
he’s going to see me through. I hear that the British
are similarly peculiar. They are polite even to
newspaper men and magazine writers. They might
even speak to a cartoonist.</p>
<p class="calibre8">Returning to our side of the Seine, I bumped into
some Australians, here on leave. One had been
in Germany before the war and could speak and
understand the “schoenste language.”</p>
<p class="calibre8">“They use me as an interpreter,” he said. “When
they bring in a bloody boche prisoner, I talk to
him. First we give him a real meal, maybe bacon
and eggs and coffee, something he hasn’t seen for<span id="Page_49" title="49"></span>
months. Then I ask him where he came from and
how he got here. Most of them are glad to tell
me the truth. Those that do, I mark them down
as ‘Very intelligent.’ Those that volunteer information
I record as ‘Extremely intelligent.’ Those
that say ‘Nicht verstehe’ go down in the record as
‘Not intelligent.’ But the majority are so bloody
well glad to be out of the war that they talk freely.</p>
<p class="calibre8">“I asked one Heinie if he was going to try to
escape. ‘Not me,’ he said, ‘I’m tickled to be here.’
They’re all fed up on the war. You’d be too with
three years of it.”</p>
<p class="calibre8">This young man admitted that he was one of the
best football players in Australia. “Maybe I’ve
forgotten how now,” he said. “I’ve been over here
three years. Just think of it—I traveled twelve
thousand miles, or maybe it’s kilos, to mix up in
this.”</p>
<p class="calibre8">Baseball, he told me, had taken a strong hold on
Australia.</p>
<p class="calibre8">“I don’t hit well,” he said, “but I can catch what
you call flies! I can catch the widest flies that are
knocked.”</p>
<p class="calibre8"><span id="Page_50" title="50"></span></p>
<p class="calibre8">Which gift would probably be useless in America,
where most of the flies knocked are bloody narrow.</p>
<p class="calibre8">Before I left him I learned also that Les Darcy
was all right at heart, but that the professional
“sports” spoiled him, and that he could have
“knocked Jack Johnson, Stanley Ketchel, Billy
Papke or Jess Willard clean out of the ring.”</p>
<p class="calibre8">He is going back to the trenches to-night, and I
hope there are plenty of extremely intelligent
Heinies there to keep him busy interpreting till his
next leave. Interpreting, I should think, would be
much pleasanter than going over the top.</p>
<h3 class="calibre10" id="pgepubid00018"> <i class="calibre11">Tuesday, August 21.</i></h3>
<p class="calibre8">This time it was an American of the French Ambulance
Service.</p>
<p class="calibre8">“Say, listen,” he said. “I can give you some
mighty good stories. Real stuff, do you get me?
Listen: One night there was a boche wounded out
there and I brought him in. He had one leg all
shot to pieces and we had to operate. I was going
to give him the ether when he turned over and
looked me in the face. ‘Why, Dan,’ he said, ‘aren’t<span id="Page_51" title="51"></span>
you going to speak to me?’ It was a chap I’d gone
to school with in America. I could give you lots
of stuff like that; do you get me? I used to be in
New York, and Rube Goldberg used to call me up
out of bed at six in the morning. ‘Dan,’ he’d say
to me, ‘I’m up against it for an idea. Will you give
me an idea?’ Do you get me? And there’s a
dramatic critic in New York—I won’t tell you his
name—but he used to tag around me after a first
night and ask me what I thought of the show. Do
you get me? I can give you a lot of good stuff.”</p>
<p class="calibre8">I told him I was afraid that if he gave it to me
all at once I wouldn’t remember any of it. So he
is coming to my hotel every day during his leave,
to give me a little at a time—if he can find me.</p>
<p class="calibre8">Last night a good-hearted American officer took
me to dinner at La Tour d’Argent, which is said
to be the oldest restaurant in Paris and which, they
say, is the place the Kaiser was going to have his
banquet on a certain night three years ago if Gott
hadn’t gone back on him at the last moment.</p>
<p class="calibre8">We ordered duck, the restaurant’s specialty.
They cook it in your presence, slice off whatever is<span id="Page_52" title="52"></span>
sliceable, and then put the bird in a press and give
you the result as gravy. After the meal they hand
you a post card on which is inscribed <i class="calibre6" lang="fr">le numéro de
votre canard</i>. I looked up “canard” in my dictionary
and found that it meant a drake, or false news,
or a worthless newspaper. I have heard lots of
false news, but I know no one took the trouble to
count the items. Also I know that my newspaper
is neither worthless nor numbered. So canard in
this case must mean drake. The number of mine
was 41654. If he had happened to disagree with
me, I could have taken his number and traced him
to the source. It’s a very good idea and might
be used in America on eggs or drinks.</p>
<p class="calibre8">I made another trip to the office which is supposed
to be in charge of American correspondents
and accommodations for them. I will go there
again to-morrow and again the next day. I will
bother them to death. Meantime I have applied to
a person in London for permission to go to the
British front, and have been assured a visit to the
French lines late next week. I have wonderful
vision and can see things twelve miles away.</p>
<p class="calibre8"><span id="Page_53" title="53"></span></p>
<p class="calibre8">P. S. It was revealed to me to-night that my
detention and trial in Bordeaux was a frame-up
conceived by loving friends aboard ship and carried
out by that English-speaking cross-examiner, who,
believe me, is a convincing actor.</p>
<p class="calibre8">Thanks, gents. It was good for about two thousand
words.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section008.vue?879894ce